"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VehicleDropOffDto = void 0;
const CustomerVehicleDto_1 = require("../customer-vehicles/CustomerVehicleDto");
const UserDto_1 = require("../users/UserDto");
class VehicleDropOffDto {
    constructor(params) {
        if (!params) {
            return;
        }
        this.id = params.id;
        this.customerVehicleId = params.customerVehicleId;
        this.status = params.status;
        this.ro = params.ro;
        this.notes = params.notes;
        this.createdAt = params.createdAt;
        this.updatedAt = params.updatedAt;
        this.datetimeType = params.datetimeType;
        this.date = params.date;
        this.time = params.time;
        this.loaner = params.loaner;
        this.customerNotes = params.customerNotes;
        this.dropOffOnly = params.dropOffOnly;
        this.timePeriod = params.timePeriod;
        this.droppedOffAt = params.droppedOffAt;
        this.datetimeConfirmedAt = params.datetimeConfirmedAt;
        this.userId = params.userId;
        this.couponCode = params.couponCode;
        if (params.customerVehicle !== undefined) {
            this.customerVehicle = params.customerVehicle === null ?
                null :
                new CustomerVehicleDto_1.CustomerVehicleDto(params.customerVehicle);
        }
        if (params.user !== undefined) {
            this.user = params.user === null ?
                null :
                new UserDto_1.UserDto(params.user);
        }
    }
}
exports.VehicleDropOffDto = VehicleDropOffDto;
//# sourceMappingURL=VehicleDropOffDto.js.map